module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAABGUlEQVQoU6XQMUoDQRgF4Pd2jcR2swnLTJNTRDyCF7AXG0+gRA9gaaWNCCKWNuIBLAKKiKUS7GdCcIQEQ0JCMr/s4ghC1sZp5//mf2/otB6BfIGIx7Ij0pwvFrtZv3+TX9Np/Zgas750GIDT+gAiw9TakwAeUmM2SoFS+wBGS4EAUYAEiojuG9SsPf21wWVZy8fxWRiE95f1Xu84AAJNko28QxHJKXUUAWY4Hl/lLz0NBp9bwCKAubUXK1p3cvDqZ7NWVKkcCnBft/ZWgNVJkjQmAKVa3QPQzTs4re/olDoXoEsgCcBp3Sa56UVYdJpOd+rOvRUglMwjBfDHF/8TkHyuGXNdsoHvSnV+In0ote3JNkR6JSAmufYFWiOXGCLWu9sAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./assets/images/icon_f2_on.png
// module id = LhMl
// module chunks = 14 17